export function generateWinnerEntries(entriesData) {
    const result = [];
  
    for (const entry of entriesData) {
      for (let i = 0; i < entry.amount; i++) {
        const winnerTicketNumber = `${entry.prizeDrawEntryId}000${i + 1}`;
        result.push({
          userId: entry.userId,
          prizeDrawEntryId: entry.prizeDrawEntryId,
          username: entry.username,
          winnerTicketNumber
        });
      }
    }
  
    return result;
  }